import { bfsUserWebHttp, otmsHttp, bmsHttp } from '@/utils/http/index.js'

/**
 * 货主认证-发送验证码
 * https://yapi.ops.yunlizhi.cn/project/154/interface/api/12948
 */
export function sendMsg(data) {
	return bfsUserWebHttp.post('/customer/apply/send_msg', data)
}

/**
 * 货主认证-上传营业执照
 * https://yapi.ops.yunlizhi.cn/project/154/interface/api/12946
 */
export function submitBusinessLicense(data) {
	return bfsUserWebHttp.post('/customer/apply/submit_business_license', data)
}

/**
 * 货主认证-提交
 * https://yapi.ops.yunlizhi.cn/project/154/interface/api/12950
 */
export function submitApply(data) {
	return bfsUserWebHttp.post('/customer/apply/submit_apply', data)
}

/**
 * 获取认证详情
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/14202
 */
export function getSignDetail(data) {
	return bfsUserWebHttp.post('/crm-plus/customer/apply/detail', data)
}

/**
 *  获取签约合同列表
 *  https://yapi.ops.yunlizhi.cn/project/210/interface/api/2181
 */
export function getSignList(data) {
	return bfsUserWebHttp.post('/bfs_econtract/user/contract/list', data)
}

/**
 *  获取签约状态
 *  https://yapi.ops.yunlizhi.cn/project/295/interface/api/8486
 */
export function getSignType(data) {
	return bfsUserWebHttp.post('/crm-plus/customer/list', data)
}

/**
 *  签约发送验证码
 *  https://yapi.ops.yunlizhi.cn/project/210/interface/api/14150
 */
export function sendSignCode(data) {
	return bfsUserWebHttp.post('/bfs_econtract/user/contract/send_sign_code', data)
}

/**
 *  添加合同签署者	
 *  https://yapi.ops.yunlizhi.cn/project/210/interface/api/14152
 */
export function addSinger(data) {
	return bfsUserWebHttp.post('/bfs_econtract/user/contract/add_singer', data)
}

/**
 *  查询用户合同详情
 *  https://yapi.ops.yunlizhi.cn/project/210/interface/api/12490
 */
export function contractDetail(data) {
	return bfsUserWebHttp.post('/bfs_econtract/user/contract/detail', data)
}

/**
 *  查询用户合同预览地址
 *  https://yapi.ops.yunlizhi.cn/project/210/interface/api/2185
 */
export function contractPreview(data) {
	return bfsUserWebHttp.post('/bfs_econtract/user/contract/preview', data)
}

/**
 *  验证码签约
 *  https://yapi.ops.yunlizhi.cn/project/210/interface/api/14154
 */
export function signWithCode(data) {
	return bfsUserWebHttp.post('/bfs_econtract/user/contract/sign_with_code', data)
}

/**
 *  获取可签约合同
 *  https://yapi.ops.yunlizhi.cn/project/202/interface/api/14332
 */
export function transcriptList(data) {
	return otmsHttp.post('/bfs_pricing_rule/contract/transcript/list', data)
}

/**
 *  手动锁定并结束已签署的合同
 *  https://yapi.ops.yunlizhi.cn/project/210/interface/api/12492
 */
export function contractLock(data) {
	return bfsUserWebHttp.post(`/bfs_econtract/user/contract/lock`, data)
}

/**
 *  BMS签约
 *  https://yapi.ops.yunlizhi.cn/project/202/interface/api/14398
 */
export function transcriptSign(data) {
	return bmsHttp.post(`/contract/transcript/sign`, data)
}
/**
 *  BMS拒绝签署
 *  https://yapi.ops.yunlizhi.cn/project/202/interface/api/14398
 */
export function confirmChange(data) {
	return bmsHttp.post(`/contract_approve/confirm_change`, data)
}

